'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DeviceProfileProvider = require('../../../common/providers/DeviceProfileProvider.js');
var ClaimsApolloProvider$1 = require('../../../common/providers/ClaimsApolloProvider.js');
var client = require('@apollo/client');
var zod = require('zod');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const createDeviceDetailsHeadersMiddleware = deviceProfile => new client.ApolloLink((operation, forward) => {
  const {
    browserFingerprint,
    deviceSizePx
  } = deviceProfile;
  const narvarTitanAnonymousIdParseResult = zod.z.string().safeParse(sessionStorage['narvar_titan_anonymous_id']);
  const narvarTitanAnonymousId = narvarTitanAnonymousIdParseResult.success ? narvarTitanAnonymousIdParseResult.data : '';
  operation.setContext(_ref => {
    let {
      headers = {}
    } = _ref;
    return {
      headers: {
        ...headers,
        'X-Browser-Fingerprint': browserFingerprint,
        'X-Device-Size': deviceSizePx,
        'X-Titan-Anonymous-Id': narvarTitanAnonymousId
      }
    };
  });
  return forward(operation);
});
const ClaimsApolloProvider = _ref2 => {
  let {
    children,
    config
  } = _ref2;
  const deviceProfile = DeviceProfileProvider.useDeviceProfile();
  return /*#__PURE__*/React__default["default"].createElement(ClaimsApolloProvider$1.ClaimsApolloProvider, {
    config: {
      ...config,
      links: [createDeviceDetailsHeadersMiddleware(deviceProfile)]
    }
  }, children);
};

exports.ClaimsApolloProvider = ClaimsApolloProvider;
